/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contour-image-container[_ngcontent-%COMP%]{text-align:center;padding:66px 0}.delete-confirmation-message[_ngcontent-%COMP%]{text-align:center;font-weight:700;padding:0 84px}.delete-confirmation-message[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{color:#219bd7;display:block}"];
export { styles as styles };
